module.exports = __webpack_public_path__ + "static/media/no_profile.2704944e.png";